import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
    `<div>
  <h4>Description - Injury</h4>
  <p>
      Injury was reported by one of the Associates, who asked for help.
  </p>
  <h4>Impact</h4>
  <p>
      Providing immediate aid is crucial to minimize the severity of harm, prevent complications. Swift intervention enhances recovery prospects and fosters a safety-conscious workplace culture.
  </p>
  <h4>Resolution Steps</h4>
  <p>
      1. Locate the Stow Associate who requested help.<br />
      2. Assess the Situation: evaluate the severity of the injury and ensure the safety of the injured person and others in the vicinity. In the event of a medical emergency, immediately contact Emergency Services.<br /><br />

         NOTE: If a trusted person is in proximity ask them to make the emergency call, while you stay with the injured person. In the call clearly state the location, type of emergency, description of the injured person and details of the injury, and your phone number.<br /><br />

      3. Escort associate to care area for assessment and if the associate consents to care, administer first aid.<br /><br />

         NOTE:  If AA requests outside care, connect them with Nurses on Demand (NoD) or call emergency services as needed.<br /><br />

      4. Immediately complete injury evaluation and assessment<br />
      5. Work with your local WHS Specialist to communicate the care plan to the Associate.<br />
      6. After following required steps, complete this work item in SCC.<br /><br />

         NOTE: If emergency services were involved, please contact GSOC with a recap of the incident.<br /><br />

      7. Document and Report this incident using internal tools: refer to UTR Injury Investigation Template and In-Station Safety SOP
  </p>
  <h4>Helpful Links</h4>
  <p>
      1. <span><a href="https://start.wwops.amazon.dev/boards/browse?boardId=IjIwMDc3Ig%3D%3D&businessUnitId=IjMi&selectedTagValueIds=WyIzMDQiLCIzMjg2IiwiMjUyNSJd&topLevelFilters=eyI0IjoiNDEiLCI2IjoiNTgifQ%3D%3D#20077">In-Station Safety</a></span><br />
      2. <span><a href="https://start.wwops.amazon.dev/boards/browse?boardId=IjE5Njc3Ig%3D%3D&businessUnitId=IjMi&selectedTagValueIds=WyIzMDQiLCIzMjg2IiwiMjUyNSJd&topLevelFilters=eyI0IjoiNDEiLCI2IjoiNTgifQ%3D%3D#19677">UTR Injury Investigation Template</a></span><br />
      3. <span><a href="https://w.amazon.com/bin/view/EHS-AUSTIN/">Austin</a></span><br />
      4. <span><a href="https://perfectmile-na.amazon.com/dashboards/16602/region/NA/daily?tab=331617&start-date=2023-09-03&end-date=2023-09-09&drilldowns=country/location&filter-in-location-type=%5B3P%2CDS%2CSC%2CXP%2CHQ%5D">NA PM safety Dashboard</a></span><br />
      5. <span><a href="https://perfectmile.amazon.com/dashboards/16602/region/EU/daily?tab=331617&start-date=2023-09-03&end-date=2023-09-09&drilldowns=country/location&filter-in-location-type=%5B3P%2CDS%2CSC%2CXP%2CHQ%5D">EU PM Safety Dashboard</a></span><br />
      6. <span><a href="https://perfectmile-fe.amazon.com/dashboards/16602/country/JP/daily?tab=331617&start-date=2023-09-03&end-date=2023-09-09&drilldowns=country/location&filter-in-location-type=%5B3P%2CDS%2CSC%2CXP%2CHQ%5D">JP PM Safety Dashboard</a></span><br />
      7. <span><a href="https://hs3c-tableau.aka.amazon.com/t/WHS/views/GRSXBR/Injuries-DeeperDive?%3Aiid=1&%3AisGuestRedirectFromVizportal=y&%3Aembed=y%231">Safety Metrics Tableau</a></span>
  </p>
</div>
`
);



// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_Help_Request_Injury.jsx